module.exports = __webpack_public_path__ + "static/media/Coin_Graphic_Sale@3x.fa824e28.png";